export const  AuditLogType  = {
    Before: 'Before',
    After: 'After',
    Info: 'Info',
  }